<template>

    <div class="c-form_pain">
        <form-label>Zaznacz punkty na mapie ciała i dodaj do nich opisy</form-label>
        <div class="c-form_pain__row">
            <div class="c-form_pain__bodies">
                <form-pain-body
                    name="front"
                    caption="widok z przodu"
                    image="body-front.svg"
                    :points="points"
                    @add-point="addPoint">
                </form-pain-body>
                <form-pain-body
                    name="left_side"
                    caption="widok z lewej strony"
                    image="body-left.svg"
                    :points="points"
                    @add-point="addPoint">
                </form-pain-body>
                <form-pain-body
                    name="back"
                    caption="widok z tyłu"
                    image="body-back.svg"
                    :points="points"
                    @add-point="addPoint">
                </form-pain-body>
                <form-pain-body
                    name="right_side"
                    caption="widok z prawej strony"
                    image="body-right.svg"
                    :points="points"
                    @add-point="addPoint">
                </form-pain-body>
            </div>
            <v-table
                v-if="points.length"
                class="c-form_pain__legend">
                <thead>
                <th>LP.</th>
                <th>Opis</th>
                <th>Skala VAS</th>
                <th>Akcje</th>
                </thead>
                <tbody>
                <tr
                    class="c-form_pain__legend-row"
                    v-for="point in points"
                    :key="point.id">
                    <td class="c-form_pain__legend-id">
                        <span>{{ point.id + 1 }}</span>
                    </td>
                    <td class="c-form_pain__legend-desc">
                        <form-input
                            v-model="point.name"
                            :speech-to-text="speechToText">
                        </form-input>
                    </td>
                    <td class="c-form_pain__legend-vas">
                        <form-input
                            v-model="point.vas_scale"
                            type="number"
                            min="0"
                            max="10"
                            @blur="checkVAS(point)">
                        </form-input>
                    </td>
                    <td class="c-form_pain__legend-actions">
                        <v-btn
                            type="icon"
                            icon="delete"
                            @click="removePoint(point)">
                        </v-btn>
                    </td>
                </tr>
                </tbody>
            </v-table>
        </div>
    </div>

</template>


<script>

import VTable from 'Components/VTable'
import VBtn from 'Components/VBtn'
import FormLabel from './FormLabel'
import FormInput from './FormInput'
import FormPainBody from './FormPainBody'

export default {

    name: 'FormPain',

    props: {
        value: Array,
        speechToText: Boolean
    },

    data() {
        return {
            idCounter: 0,
            points: this.value || []
        }
    },

    methods: {
        addPoint(view, e) {
            this.points.push({
                id: this.idCounter++,
                view: view,
                x_position: Math.round(100 * (e.offsetX / e.target.clientWidth)),
                y_position: Math.round(100 * (e.offsetY / e.target.clientHeight)),
                name: '',
                vas_scale: 0
            })
        },
        removePoint(point) {
            const index = this.points.indexOf(point)
            if (index >= 0)
                this.points.splice(index, 1)
            this.renumber()
        },
        checkVAS(point) {
            if (point.vas_scale > 10)
                point.vas_scale = 10

            else if (point.vas_scale < 0)
                point.vas_scale = 0
        },
        renumber() {
            this.idCounter = 0
            const len = this.points.length
            for (var i = 0; i < len; i++) {
                this.points[i].id = this.idCounter++
            }
        }
    },

    watch: {
        value(value) {
            this.points = value
            this.renumber()
        },
        points(value) {
            this.$emit('input', value)
        }
    },

    created() {
        this.renumber()
    },

    components: {
        VBtn,
        VTable,
        FormLabel,
        FormInput,
        FormPainBody
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-form_pain {
    width: 100%;

    &__bodies {
        margin-top: 1rem;
        display: flex;
        justify-content: space-between;
        width: 100%;
    }
    &__legend {
        margin-top: 1rem;
        margin-bottom: 2.4rem;
        width: 100%;

        .c-form_input {
            margin: 0;

            &__inner {
                display: block;
            }
        }
        tbody td {
            padding: 0.3rem .7rem;
            vertical-align: bottom;
        }
        &-id {
            width: 50px;

            span {
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 3px 0;
                width: 2rem;
                height: 2rem;
                border-radius: 50%;
                background-color: $c-primary;
                color: $c-white;
                font-weight: 400;
            }
        }
        &-vas {
            max-width: 70px;
        }
        &-desc {
            width: 100%;
            min-width: 250px;
        }
        &-actions {
            max-width: 80px;

            button {
                margin: 3px 0;
            }
        }
    }
}

</style>
